import React from "react";
import { useLang } from "../i18n";

// Brand logos — official files stored under /public/logos/
const PayPalLogo = () => (
  <img src="/logos/paypal.svg" alt="PayPal" className="h-7 w-auto object-contain" loading="lazy" />
);

const VisaLogo = () => (
  <img src="/logos/visa.svg" alt="Visa" className="h-7 w-auto object-contain" loading="lazy" />
);

const MastercardLogo = () => (
  <img src="/logos/mastercard.svg" alt="Mastercard" className="h-7 w-auto object-contain" loading="lazy" />
);

const BrtLogo = () => (
  <img
    src="/logos/brt.png"
    alt="BRT Corriere Espresso"
    className="h-9 w-auto object-contain"
    loading="lazy"
  />
);

const GlsLogo = () => (
  <img
    src="/logos/gls.jpg"
    alt="GLS Corriere Espresso"
    className="h-9 w-auto object-contain"
    loading="lazy"
  />
);

const PosteLogo = () => (
  <img
    src="/logos/poste.png"
    alt="Poste Italiane"
    className="h-9 w-auto object-contain"
    loading="lazy"
  />
);

const TrustStrip = () => {
  const { lang } = useLang();
  const labels = {
    pay: lang === "it" ? "Pagamento sicuro con:" : "Secure payment with:",
    ship: lang === "it" ? "Spediamo con:" : "We ship with:",
  };

  return (
    <div
      data-testid="trust-strip"
      className="bg-amber-50 border-t-4 border-b-4 border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 grid md:grid-cols-2 gap-6 md:gap-12 items-center">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
          <span className="font-display font-bold text-slate-900 text-sm tracking-wide shrink-0">
            {labels.pay}
          </span>
          <div className="flex items-center gap-4 flex-wrap">
            <div data-testid="logo-paypal" className="bg-white border-2 border-slate-200 rounded-lg px-3 py-1.5">
              <PayPalLogo />
            </div>
            <div data-testid="logo-mastercard" className="bg-white border-2 border-slate-200 rounded-lg px-3 py-1.5">
              <MastercardLogo />
            </div>
            <div data-testid="logo-visa" className="bg-white border-2 border-slate-200 rounded-lg px-3 py-1.5">
              <VisaLogo />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 md:justify-end">
          <span className="font-display font-bold text-slate-900 text-sm tracking-wide shrink-0">
            {labels.ship}
          </span>
          <div className="flex items-center gap-3 flex-wrap">
            <div data-testid="logo-brt" className="bg-white border-2 border-slate-200 rounded-lg px-2 py-1 flex items-center">
              <BrtLogo />
            </div>
            <div data-testid="logo-gls" className="bg-white border-2 border-slate-200 rounded-lg px-2 py-1 flex items-center">
              <GlsLogo />
            </div>
            <div data-testid="logo-poste" className="bg-white border-2 border-slate-200 rounded-lg px-2 py-1 flex items-center">
              <PosteLogo />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
